import React from 'react';
import Button from '@material-ui/core/Button';
import GridContainer from "../components/Grid/GridContainer";
import GridItem from "../components/Grid/GridItem";
import ListItem from "@material-ui/core/ListItem";
import _, { omit, pick, round, slice } from 'lodash';
import InputAdornment from "@material-ui/core/InputAdornment";
import { FormControl, FormLabel, FormHelperText, Paper, Chip, Card, CardHeader, CardMedia, CardContent, CardActions, Avatar } from '@material-ui/core';
import { actions } from "../reducers/app";
import { useDispatch, useSelector } from "react-redux";
import PF from "../_Services/publicFunction";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Typography from '@material-ui/core/Typography';
import Qs from "qs";
import { makeStyles, withStyles } from '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';
import { Bar } from 'react-chartjs-2';
import Divider from '@material-ui/core/Divider';
import useSound from 'use-sound';
import clickdown from '../sounds/clickdown.wav';
import clickup from '../sounds/clickdown.wav';
import { injectIntl, intlShape, useIntl, FormattedMessage } from 'react-intl';
import { useSnackbar } from "notistack";

const BorderLinearProgress = withStyles((theme) => ({
    root: {
        height: 8,
        // borderRadius: 5,
    },
    colorPrimary: {
        //backgroundColor: theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
    },
    bar: {
        // borderRadius: 5,
        backgroundColor: '#1a90ff',
    },
}))(LinearProgress);

const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(3),
    },
    button: {
        margin: theme.spacing(1, 1, 0, 0),
    },
    root: {
        color: theme.palette.type === "dark" ? "#1a90ff" : "#3f51b5"
    },
    submitButton: {
        width: "100%", background: '#2E3B55', fontWeight: "bold",
        "&:hover": {
            background: '#fffff',
            // color:'#2E3B55'
        }
    },
    root3: {
        // display: 'flex',
        // flexWrap: 'wrap',
        '& > *': {
            margin: theme.spacing(1),
            // width: theme.spacing(16),
            // height: theme.spacing(16),
        },
    },

}));

const Questionaire67th = props => {
    const intl = useIntl();

    const [numerator, setNumerator] = React.useState(0)     //ProgressBar分子
    const [denominator, setDenominator] = React.useState(13)//ProgressBar分母
    const transfer = {
        0: 100,
        1: 75,
        2: 50,
        3: 25,
        4: 0,
    }
    const transferReverse = {
        0: 0,
        1: 25,
        2: 50,
        3: 75,
        4: 100,
    }
    const { handleNext, setActiveStep } = props;
    const classes = useStyles();
    const [playActive] = useSound(
        clickdown,
        { volume: 0.25 }
    );
    const [playOn] = useSound(
        clickup,
        { volume: 0.25 }
    );
    const [uploadFormat, setUpload] = React.useState({
        0: { BarCodeStr: "", QuestionNo: 67, Category: "填寫前說明", titleNo: "", Title: "說明：本量表所列舉的問題是為協助您瞭解您的身心適應狀況，請您仔細回想在最近一星期中(包括今天)，這些問題使您感到困擾或苦惱的程度，然後圈選一個您認為最能代表您感覺的答案。", SelectTitle: "", Answer: "", Other: "" },
        1: { BarCodeStr: "", QuestionNo: 67, Category: "一、個人疲勞", titleNo: 1, Title: "你常覺得疲勞嗎?", SelectTitle: "○總是  ○常常  ○有時候  ○不常  ○從未或幾乎從未", Answer: "", Other: "" },
        2: { BarCodeStr: "", QuestionNo: 67, Category: "一、個人疲勞", titleNo: 2, Title: "你常覺得身體上體力透支嗎?", SelectTitle: "○總是  ○常常  ○有時候  ○不常  ○從未或幾乎從未", Answer: "", Other: "" },
        3: { BarCodeStr: "", QuestionNo: 67, Category: "一、個人疲勞", titleNo: 3, Title: "你常覺得情緒上心力交瘁嗎?", SelectTitle: "○總是  ○常常  ○有時候  ○不常  ○從未或幾乎從未", Answer: "", Other: "" },
        4: { BarCodeStr: "", QuestionNo: 67, Category: "一、個人疲勞", titleNo: 4, Title: "你常會覺得，「我快要撐不下去了」嗎?", SelectTitle: "○總是  ○常常  ○有時候  ○不常  ○從未或幾乎從未", Answer: "", Other: "" },
        5: { BarCodeStr: "", QuestionNo: 67, Category: "一、個人疲勞", titleNo: 5, Title: "你常覺得精疲力竭嗎?", SelectTitle: "○總是  ○常常  ○有時候  ○不常  ○從未或幾乎從未", Answer: "", Other: "" },
        6: { BarCodeStr: "", QuestionNo: 67, Category: "一、個人疲勞", titleNo: 6, Title: "你常常覺得虛弱，好像快要生病了嗎?", SelectTitle: "○總是  ○常常  ○有時候  ○不常  ○從未或幾乎從未", Answer: "", Other: "" },
        7: { BarCodeStr: "", QuestionNo: 67, Category: "二、工作疲勞", titleNo: 1, Title: "你的工作會令人情緒上心力交瘁嗎？", SelectTitle: "○很嚴重  ○嚴重  ○有一些  ○輕微  ○非常輕微", Answer: "", Other: "" },
        8: { BarCodeStr: "", QuestionNo: 67, Category: "二、工作疲勞", titleNo: 2, Title: "你的工作會讓你覺得快要累垮了嗎?", SelectTitle: "○很嚴重  ○嚴重  ○有一些  ○輕微  ○非常輕微", Answer: "", Other: "" },
        9: { BarCodeStr: "", QuestionNo: 67, Category: "二、工作疲勞", titleNo: 3, Title: "你的工作會讓你覺得挫折嗎?", SelectTitle: "○很嚴重  ○嚴重  ○有一些  ○輕微  ○非常輕微", Answer: "", Other: "" },
        10: { BarCodeStr: "", QuestionNo: 67, Category: "二、工作疲勞", titleNo: 4, Title: "工作一整天之後，你覺得精疲力竭嗎?", SelectTitle: "○總是  ○常常  ○有時候  ○不常  ○從未或幾乎從未", Answer: "", Other: "" },
        11: { BarCodeStr: "", QuestionNo: 67, Category: "二、工作疲勞", titleNo: 5, Title: "上班之前只要想到又要工作一整天，你就覺得沒力嗎?", SelectTitle: "○總是  ○常常  ○有時候  ○不常  ○從未或幾乎從未", Answer: "", Other: "" },
        12: { BarCodeStr: "", QuestionNo: 67, Category: "二、工作疲勞", titleNo: 6, Title: "上班時你會覺得每一刻都很難熬嗎?", SelectTitle: "○總是  ○常常  ○有時候  ○不常  ○從未或幾乎從未", Answer: "", Other: "" },
        13: { BarCodeStr: "", QuestionNo: 67, Category: "二、工作疲勞", titleNo: 7, Title: "不工作的時候，你有足夠的精力陪朋友或家人嗎?", SelectTitle: "○總是  ○常常  ○有時候  ○不常  ○從未或幾乎從未", Answer: "", Other: "" },
        14: { BarCodeStr: "", QuestionNo: 67, Category: "三、計分方式", titleNo: 1, Title: "『總是』表示100分 ；『常常』表示75分 ；『有時候』表示50分 ；『不常』表示25分；『幾乎從未』表示0分", SelectTitle: "", Answer: "", Other: "" },
        15: { BarCodeStr: "", QuestionNo: 67, Category: "三、計分方式", titleNo: 2, Title: "個人相關過勞分數，將第 1~6 題的得分相加，除以 6，可得個人相關過勞分數：", SelectTitle: "_分", Answer: "", Other: "" },
        16: { BarCodeStr: "", QuestionNo: 67, Category: "三、計分方式", titleNo: 3, Title: "工作相關過勞分數，將第 1~6 題的得分與題7分數轉換相加，除以7，可得工作相關過勞分數：", SelectTitle: "_分", Answer: "", Other: "" },
        17: { BarCodeStr: "", QuestionNo: 67, Category: "四、分數解釋", titleNo: 1, Title: "個人相關過勞分數50 分以下，等級：輕微", SelectTitle: "您的過勞程度輕微，您並不常感到疲勞、體力透支、精疲力竭、或者虛弱好像快生病的樣子。", Answer: "", Other: "" },
        18: { BarCodeStr: "", QuestionNo: 67, Category: "四、分數解釋", titleNo: 2, Title: "個人相關過勞分數50 -70分，等級：中度", SelectTitle: "你的個人過勞程度中等。您有時候感到疲勞、體力透支、精疲力竭、或者虛弱好像快生病的樣子。建議您找出生活的壓力源，進一步的調適自己，增加放鬆與休息的時間。", Answer: "", Other: "" },
        19: { BarCodeStr: "", QuestionNo: 67, Category: "四、分數解釋", titleNo: 3, Title: "個人相關過勞分數70 分以上，等級：嚴重", SelectTitle: "您的個人過勞程度嚴重。您時常感到疲勞、體力透支、精疲力竭、或者虛弱好像快生病的樣子。建議您適度的改變生活方式，增加運動與休閒時間之外，您還需要進一步尋找專業人員諮詢。", Answer: "", Other: "" },
        20: { BarCodeStr: "", QuestionNo: 67, Category: "四、分數解釋", titleNo: 4, Title: "工作相關過勞分數45 分以下，等級：輕微", SelectTitle: "您的工作相關過勞程度輕微，您的工作並不會讓您感覺很沒力、心力交瘁、很挫折。", Answer: "", Other: "" },
        21: { BarCodeStr: "", QuestionNo: 67, Category: "四、分數解釋", titleNo: 5, Title: "工作相關過勞分數45 -60分，等級：中度", SelectTitle: "您的工作相關過勞程度中等，您有時對工作感覺沒力，沒有興趣，有點挫折。", Answer: "", Other: "" },
        22: { BarCodeStr: "", QuestionNo: 67, Category: "四、分數解釋", titleNo: 6, Title: "工作相關過勞分數60 分以上，等級：嚴重", SelectTitle: "您的工作相關過勞程度嚴重，您已經快被工作累垮了，您感覺心力交瘁，感覺挫折，而且上班時都很難熬，此外您可能缺少休閒時間，沒有時間陪伴家人朋友。建議您適度的改變生活方式，增加運動與休閒時間之外，您還需要進一步尋找專業人員諮詢。", Answer: "", Other: "" },
    });
    const [done, setDone] = React.useState(false);
    const formRef = React.createRef();
    const dispatch = useDispatch();
    const { UserInfo } = useSelector(state => ({
        UserInfo: state.app.UserInfo,
    }));
    React.useEffect(() => {
        //寫入BarCodeStr
        let obj = Object.values(uploadFormat).reduce((o, { }, index) => {
            o[index] = { BarCodeStr: UserInfo.BarCodeStr }
            return o
        }, {})
        let newitem = _.merge(uploadFormat, obj);
        // console.log(newitem)
        setUpload(prevState => newitem);
    }, [])
    const handleSubmit = e => {
        e.preventDefault();
        //寫上分數

        //setError(!error);
        if (validator()) {


            dispatch(actions.TAB_EDIT({ editing: true, key: 67 }))
            PF.instance({
                method: "post",
                url: PF.url + "/Questionaire/Insert",
                data: Qs.stringify({ list: Object.values(uploadFormat) }),
                headers: { token: sessionStorage.token }
            })
                .then(function (response) {
                    console.log(response.data)
                    const { TotalRecord, ErrorMessage } = response.data
                    if (TotalRecord <= 0) {
                        alert("問卷提交出錯\r\n" + ErrorMessage + "請致電 04-2255-2555 #168 企業健檢")
                        enqueueSnackbar(intl.formatMessage({ id: "update fail" }), { variant: "error", style: { whiteSpace: 'pre-line' } });
                    } else {
                        setActiveStep((prevActiveStep) => prevActiveStep + 1);
                        setDone(true);
                        enqueueSnackbar(intl.formatMessage({ id: "update success" }), { variant: "success", style: { whiteSpace: 'pre-line' } });
                    }
                })
        }
    }
    const { enqueueSnackbar } = useSnackbar();

    const validator = () => {
        const form = formRef.current; //參數1
        if (form.checkValidity()) {
            // console.log("全部通過")
            //若驗證通過，刪除錯誤提示
            for (let i = 0; i < form.elements.length; i++) {
                const element = form.elements[i];

                if (Object.keys(uploadFormat).includes(element.name)) {
                    setUpload(prevState => ({
                        ...prevState,
                        [element.name]: omit(prevState[element.name], ["error", "helperText"])
                    }));
                }

            }
            return true;
        } else {
            // const form = formRef.current;
            // console.log("還沒通過")
            alert(intl.formatMessage({ id: "尚有問題未完成" }));
            for (let i = 0; i < form.elements.length; i++) {
                const element = form.elements[i];
                if (element.tagName !== 'button' && element.willValidate && !element.validity.valid) {  //提交按鈕不用驗證
                    console.log(element.validationMessage, element.name);
                    console.log(element.value)
                    // console.log(element.value, element.validationMessage, element.name, element.tagName)
                    if (Object.keys(uploadFormat).includes(element.name)) {
                        setUpload(prevState => ({
                            ...prevState,
                            [element.name]: { ...prevState[element.name], error: true, helperText: element.validationMessage }
                        }));
                    }


                } else {//驗證通過，自訂訊息
                    //有在settingObj的
                    console.log("Pass", element.value, element.validationMessage, element.name, element.tagName)
                    if (Object.keys(uploadFormat).includes(element.name)) {
                        setUpload(prevState => ({
                            ...prevState,
                            [element.name]: omit(prevState[element.name], ["error", "helperText"])
                        }));
                    }

                }
            }
            return false;
        }
    }
    let [obj, setObj] = React.useState({});

    const handleRadioChange = e => {
        // e.prevetDefault();
        // console.log(uploadFormat)
        if (!done) {
            const { name, value } = e.target;

            let x = e.target.getAttribute("data")
            //分數轉換
            setObj(prev => ({
                ...prev,
                [name]: name >= 13 ? transferReverse[x] : transfer[x]
            }))
            setUpload(prevState => ({
                ...prevState,
                [name]: { ...prevState[name], Answer: value }
            }))
            if (uploadFormat[name].Answer === "") {
                // setProgress(prev => prev < 99.97 ? (prev + 7.69) : prev)
                setNumerator(prev => prev + 1)
            }
        }
    }
    const initialRender = React.useRef(true);
    const [scores1, setScores1] = React.useState(0);
    const [scores2, setScores2] = React.useState(0);
    const cal_score = () => {
        //let y = Object.values(obj).slice(1, 6).map((a, b) => (transfer[a.Answer]));
        //let x = Object.values(obj).slice(6, 13).map((a, b) => (transfer[a.Answer]));
        const keys1 = Object.keys(obj).filter(num => parseInt(num) <= 6)
        // console.log(Object.keys(obj))

        let acc1 = 0
        keys1.map(k => {
            // console.log(k);
            acc1 += obj[k]
        })
        // console.log(keys1)
        // console.log(acc1/keys1.length)
        setScores1(isNaN(acc1 / keys1.length) ? 0 : Math.round(acc1 / keys1.length));

        const keys2 = Object.keys(obj).filter(num => num > 6)
        let acc2 = 0
        keys2.map(k => {
            acc2 += obj[k]
        })
        // console.log(keys2)
        // console.log(acc2/keys2.length)
        setScores2(isNaN(acc2 / keys2.length) ? 0 : Math.round(acc2 / keys2.length));
        // let z = y.reduce((a, b) => a + (b === undefined ? 0 : b), 0);
        // // console.log(z)
        // setScores1(z)
        setUpload(prevState => ({
            ...prevState,
            15: { ...prevState[15], Other: isNaN(acc1 / keys1.length) ? 0 : Math.round(acc1 / keys1.length) },
            16: { ...prevState[16], Other: isNaN(acc2 / keys2.length) ? 0 : Math.round(acc2 / keys2.length) },
        }));


    }
    React.useEffect(() => {
        if (initialRender.current) {
            initialRender.current = false
        } else {

            cal_score();

        }
        // console.log("?");
    }, [obj])


    return (
        <Paper>
            <h1 style={{ textAlign: "center" }}><FormattedMessage id={"過勞評估量表"} /></h1>
            <form onSubmit={handleSubmit} ref={formRef} noValidate>
                <fieldset>
                    <legend align="left" style={{ fontWeight: "bold" }}><Typography variant="h6" style={{ fontWeight: 600 }}><FormattedMessage id={"填寫前說明"} /></Typography></legend>
                    <Typography><FormattedMessage id={uploadFormat[0].Title} /></Typography>
                </fieldset>
                <fieldset>
                    <legend align="left" style={{ fontWeight: "bold" }}><Typography variant="h6" style={{ fontWeight: 600 }}><FormattedMessage id={"個人疲勞"} /></Typography></legend>
                    {Object.values(uploadFormat).slice(1, 7).map((item, index) => {
                        return (
                            <FormControl component="fieldset" error={item.error} required className={classes.formControl} key={index}>
                                <FormLabel component="legend" className={classes.root}>{item.titleNo + "."}<FormattedMessage id={item.Title} /></FormLabel>
                                <RadioGroup name={item.titleNo} value={item.Answer} onChange={handleRadioChange} style={{ display: "block" }}>
                                    {item.SelectTitle.replaceAll("○", "").split("  ").map((pro, index) => {

                                        return (
                                            <FormControlLabel
                                                value={pro}
                                                control={<Radio color="primary" required inputProps={{ data: index }}
                                                />}
                                                label={<FormattedMessage id={pro} />}
                                                onMouseDown={() => { playActive() }}
                                            />)
                                    })}
                                </RadioGroup>
                                <FormHelperText>{item.error ? <FormattedMessage id={item.helperText} /> : null}</FormHelperText>
                            </FormControl>)
                    })}
                </fieldset>
                <fieldset>
                    <legend align="left" style={{ fontWeight: "bold" }}><Typography variant="h6" style={{ fontWeight: 600 }}><FormattedMessage id={"工作疲勞"} /></Typography></legend>
                    {Object.values(uploadFormat).slice(7, 14).map((item, index) => {
                        return (
                            <FormControl component="fieldset" error={item.error} required className={classes.formControl} key={index + 6}>
                                <FormLabel component="legend" className={classes.root}>{item.titleNo + "."}<FormattedMessage id={item.Title} /></FormLabel>
                                <RadioGroup name={item.titleNo + 6} value={item.Answer} onChange={handleRadioChange} style={{ display: "block" }}>
                                    {item.SelectTitle.replaceAll("○", "").split("  ").map((pro, index) => {
                                        return (
                                            <FormControlLabel value={pro} control={<Radio color="primary" required inputProps={{ data: index }} />} label={<FormattedMessage id={pro} />} onMouseDown={() => { playActive() }} />)
                                    })}
                                </RadioGroup>
                                <FormHelperText>{item.error ? <FormattedMessage id={item.helperText} /> : null}</FormHelperText>
                            </FormControl>)
                    })}
                </fieldset>
                <fieldset style={{ marginBottom: "50px" }} >
                    <legend align="left" style={{ fontWeight: "bold" }}><Typography variant="h6" style={{ fontWeight: 600 }}><FormattedMessage id={"分數解釋"} /></Typography></legend>
                    <GridContainer>
                        <GridItem xs={12} sm={12} md={12}>
                            <Typography>{"1. "}<FormattedMessage id={"個人相關過勞"} /></Typography>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={6}>
                            <div className={classes.root3}>
                                <Paper elevation={_.inRange(scores1, 0, 50) ? 3 : 0}>
                                    <Typography variant={_.inRange(scores1, 0, 50) ? "h6" : "body1"} style={{ color: _.inRange(scores1, 0, 50) ? "rgba(75, 192, 192)" : "" }}>
                                        <FormattedMessage id={"50 分以下"} />
                                        <Chip size="small" label={<FormattedMessage id={"輕微"} />} style={{ backgroundColor: _.inRange(scores1, 0, 50) ? "rgba(75, 192, 192)" : "" }} />
                                        <FormattedMessage id={"您的過負荷程度輕微，您並不常感到疲勞、體力透支、精疲力竭、或者虛弱好像快生病的樣子。"} />
                                    </Typography>
                                </Paper>
                                <Paper elevation={_.inRange(scores1, 50, 70) ? 3 : 0}>

                                    <Typography variant={_.inRange(scores1, 50, 70) ? "h6" : "body1"} style={{ color: _.inRange(scores1, 50, 70) ? "rgba(255, 206, 86)" : "" }}>
                                        <FormattedMessage id={"50－70 分"} />
                                        <Chip size="small" label={<FormattedMessage id={"中度"} />} style={{ backgroundColor: _.inRange(scores1, 50, 70) ? "rgba(255, 206, 86)" : "" }} />
                                        <FormattedMessage id={"你的個人過負荷程度中等。您有時候感到疲勞、體力透支、精疲力竭、或者虛弱好像快生病的樣子。建議您找出生活的壓力源，進一步的調適自己，增加放鬆與休息的時間。"} />
                                    </Typography>
                                </Paper>
                                <Paper elevation={_.inRange(scores1, 70, 100.1) ? 3 : 0}>
                                    <Typography variant={_.inRange(scores1, 70, 100.1) ? "h6" : "body1"} style={{ color: _.inRange(scores1, 70, 100.1) ? "rgba(255, 99, 132)" : "" }}>
                                        <FormattedMessage id={"70 分以上"} />
                                        <Chip size="small" label={<FormattedMessage id={"嚴重"} />} style={{ backgroundColor: _.inRange(scores1, 70, 100.1) ? "rgba(255, 99, 132)" : "" }} />
                                        <FormattedMessage id={"您的個人過負荷程度嚴重。您時常感到疲勞、體力透支、精疲力竭、或者虛弱好像快生病的樣子。建議您適度的改變生活方式，增加運動與休閒時間之外，您還需要進一步尋找專業人員諮詢。"} />
                                    </Typography>
                                </Paper>
                            </div>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={6} style={{ margin: "auto", flex: "0" }}>
                            <Paper>
                                <HorizontalBarChart score={scores1} label={intl.formatMessage({ id: "個人相關過勞" })} range1={50} range2={70} />
                            </Paper>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={12}>
                            <Typography>{"2. "}<FormattedMessage id={"工作相關過勞"} /></Typography>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={6} >
                            <div className={classes.root3}>
                                <Paper elevation={_.inRange(scores2, 0, 45) ? 3 : 0}>
                                    <Typography variant={_.inRange(scores2, 0, 45) ? "h6" : "body1"} style={{ color: _.inRange(scores2, 0, 45) ? "rgba(75, 192, 192)" : "" }}>
                                        <FormattedMessage id={"45 分以下"} />
                                        <Chip size="small" label={<FormattedMessage id={"輕微"} />} style={{ backgroundColor: _.inRange(scores2, 0, 45) ? "rgba(75, 192, 192)" : "" }} />
                                        <FormattedMessage id={"您的工作相關過負荷程度輕微，您的工作並不會讓您感覺很沒力、心力交瘁、很挫折。"} />
                                    </Typography>
                                </Paper>
                                <Paper elevation={_.inRange(scores2, 45, 60) ? 3 : 0}>
                                    <Typography variant={_.inRange(scores2, 45, 60) ? "h6" : "body1"} style={{ color: _.inRange(scores2, 45, 60) ? "rgba(255, 206, 86)" : "" }}>
                                        <FormattedMessage id={"45－60 分"} />
                                        <Chip size="small" label={<FormattedMessage id={"中度"} />} style={{ backgroundColor: _.inRange(scores2, 45, 60) ? "rgba(255, 206, 86)" : "" }} />
                                        <FormattedMessage id={"您的工作相關過負荷程度中等，您有時對工作感覺沒力，沒有興趣，有點挫折。"} />
                                    </Typography>
                                </Paper>
                                <Paper elevation={_.inRange(scores2, 60, 100.1) ? 3 : 0}>
                                    <Typography variant={_.inRange(scores2, 60, 100.1) ? "h6" : "body1"} style={{ color: _.inRange(scores2, 60, 100.1) ? "rgba(255, 99, 132)" : "" }}>
                                        <FormattedMessage id={"60 分以上"} />
                                        <Chip size="small" label={<FormattedMessage id={"嚴重"} />} style={{ backgroundColor: _.inRange(scores2, 60, 100.1) ? "rgba(255, 99, 132)" : "" }} />
                                        <FormattedMessage id={"您的工作相關過負荷程度嚴重，您已經快被工作累垮了，您感覺心力交瘁，感覺挫折，而且上班時都很難熬，此外您可能缺少休閒時間，沒有時間陪伴家人朋友。建議您適度的改變生活方式，增加運動與休閒時間之外，您還需要進一步尋找專業人員諮詢。"} />
                                    </Typography>
                                </Paper>
                            </div>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={6} style={{ margin: "auto", flex: "0" }}>
                            <Paper>
                                <HorizontalBarChart score={scores2} label={intl.formatMessage({ id: "工作相關過勞" })} range1={45} range2={60} />
                            </Paper>
                        </GridItem>
                    </GridContainer>
                </fieldset>
                <div style={{ width: '100%', bottom: !done ? "36px" : "0px", position: "fixed", }}>
                    <BorderLinearProgress variant="determinate" value={(numerator / denominator) * 100} />
                </div><br /><br />
                {!done ? (<div style={{ top: 'auto', bottom: 0, position: "fixed", width: "100%" }}>
                    <Button variant="contained" color="primary" type="submit" onClick={handleSubmit} className={classes.submitButton}><FormattedMessage id={"app.Submit"} /></Button>
                </div>) : null}
            </form>
        </Paper>
    )



}

export default Questionaire67th


const HorizontalBarChart = React.memo((props) => {
    const { score, label, range1, range2 } = props;
    // console.log("rerender")
    const getColor = s => {
        switch (true) {
            case (s < range1):
                return finColor["green"]
            case (s < range2):
                return finColor["yello"]
            case (s <= 100):
                return finColor["red"]
            default:
                console.log("none");
                break;
        }
    }
    const color = {
        red: "rgba(255, 99, 132,0.2)",
        orange: "rgba(255, 159, 64,0.2)",
        yello: "rgba(255, 206, 86,0.2)",
        green: "rgba(75, 192, 192,0.2)"
    }
    const finColor = {
        red: "rgba(255, 99, 132)",
        orange: "rgba(255, 159, 64)",
        yello: "rgba(255, 206, 86)",
        green: "rgba(75, 192, 192)"
    }

    let data = {
        labels: [score],
        datasets: [
            {
                label: label,
                data: [score],
                backgroundColor: [
                    getColor(score)
                ],

            }
        ],
    };

    const options = {
        indexAxis: 'y',
        // Elements options apply to all of the options unless overridden in a dataset
        // In this case, we are setting the border of each horizontal bar to be 2px wide
        elements: {
            bar: {
                // borderWidth: 2,
            },
        },
        scales: {
            x: {
                max: 100,
                min: 0,
                ticks: {
                    beginAtZero: true,  //整數
                    stepSize: 20,

                },

            },
            y: {

                ticks: {
                    font: {
                        size: 20,
                    }
                }

            }
        },
        responsive: false,
        plugins: {
            legend: {
                position: 'top',
            },
            // title: {
            //     display: true,
            //     text: '累計得分',
            // },
        },
    };


    return (
        <Bar data={data} options={options} height={200} />
    )
})


